export const mainPopUpPortalId = "main-popup-portal";